import { render, staticRenderFns } from "./VldSchemeSmartPrepaid.vue?vue&type=template&id=810515e6&scoped=true&"
import script from "./VldSchemeSmartPrepaid.vue?vue&type=script&lang=js&"
export * from "./VldSchemeSmartPrepaid.vue?vue&type=script&lang=js&"
import style0 from "./VldSchemeSmartPrepaid.vue?vue&type=style&index=0&id=810515e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810515e6",
  null
  
)

export default component.exports